import { useTranslation } from 'react-i18next';

// Subscribe without remounting the screen: changing language preserves drafts,
// focus, selected records and the remembered state of contextual help.
export function useUiLanguage() {
  const { i18n } = useTranslation();
  return i18n.resolvedLanguage || i18n.language;
}
